import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css_files/Homepage/Navbar.css";
import DetailsRoleTable from "../Admin/DetailsRoleTable";
import { triggerscroll } from "./Homepage";
import axiosInstance, { setSessionExpiredHandler } from "../../api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

function Navbar({
  expiredSession,
  setshowchangepasswordform,
  userData,
  setisloggedout,
  navbarRef,
  sidebarRef,
  setshowtext,
  setMobileMode,
  setRightSide,
  setLeftSide,
  rightSide,
  leftSide,
  mobileMode,
}) {
  const navigate = useNavigate();
  const detailref = useRef();
  const [detailsrole, setdetailsrole] = useState(false);
  const togglemenu = useRef();
  const { setExpiredSession } = useContext(triggerscroll);

  useEffect(() => {
    setSessionExpiredHandler(() => {
        setExpiredSession(true);
    });
  }, []);

  return (
    <>
      <nav
        className="navbar"
        onMouseLeave={() => {
          if (detailref.current) {
            detailref.current.style.display = "none";
          }
        }}
        ref={navbarRef}
      >
        {expiredSession && (
          <mark
            style={{ padding: "0.5rem", fontWeight: "bold", width: "100%" }}
          >
            Your Session Has Expired. Click{" "}
            <a
              href="#"
              onClick={() => {
                document.cookie = "token=; max-age=0; path=/;";
                navigate("/");
              }}
            >
              here
            </a>{" "}
            to Login Again
          </mark>
        )}
        <nav>
          <i
            class={`fa-solid ${leftSide ? "fa-xmark" : "fa-bars"} fa-2x`}
            id="navbar-menu-toggle-icon"
            onClick={() => {
              sidebarRef.current.style.height = `calc(100vh - ${navbarRef.current.clientHeight}px)`;
              sidebarRef.current.style.top = `${navbarRef.current.clientHeight}px`;
              setMobileMode(true);
              setshowtext(true);
              if (sidebarRef.current.style.display === "block") {
                sidebarRef.current.style.display = "none";
                setLeftSide(false);
              } else {
                sidebarRef.current.style.display = "block";
                setLeftSide(true);
              }
            }}
          ></i>
          <div className="navbar-left">
            <img
              src="/images/Image 905.jpg"
              alt="Company Logo"
              id="navbar-logo"
            />
            <span className="company-name">Ross Boilers</span>
          </div>

          <div className="navbar-right" ref={togglemenu}>
            <button
              className="navbar-icon"
              onClick={() => {
                navigate("/dashboard");
                if (mobileMode) {
                  togglemenu.current.style.display = "none";
                  setRightSide(false);
                }
              }}
            >
              <i className="fa-solid fa-chart-pie"></i>
              <span>Dashboard</span>
            </button>

            {userData && userData.role === "Administrator" && (
              <>
                <button
                  className="navbar-icon"
                  onClick={() => {
                    navigate("/dashboard/reports");
                    if (mobileMode) {
                      togglemenu.current.style.display = "none";
                      setRightSide(false);
                    }
                  }}
                >
                  <i class="fa-solid fa-clipboard-list"></i>
                  <span>Reports</span>
                </button>
                <button
                  className="navbar-icon"
                  onClick={() => {
                    navigate("/dashboard/customers");
                    if (mobileMode) {
                      togglemenu.current.style.display = "none";
                      setRightSide(false);
                    }
                  }}
                >
                  <i class="fa-solid fa-users-gear"></i>
                  <span>Customers</span>
                </button>
                <button
                  className="navbar-icon"
                  onClick={() => {
                    navigate("/dashboard/customer-enquiries");
                    if (mobileMode) {
                      togglemenu.current.style.display = "none";
                      setRightSide(false);
                    }
                  }}
                >
                  <i className="fa-solid fa-envelope"></i>
                  <span>Enquiries</span>
                </button>

                <button
                  className="navbar-icon"
                  onClick={() => {
                    navigate("admin/users");
                    if (mobileMode) {
                      togglemenu.current.style.display = "none";
                      setRightSide(false);
                    }
                  }}
                >
                  <i class="fa-solid fa-users"></i>
                  <span>Users</span>
                </button>
                <button
                  className="navbar-icon"
                  onClick={() => {
                    navigate("admin/roles");
                    if (mobileMode) {
                      togglemenu.current.style.display = "none";
                      setRightSide(false);
                    }
                  }}
                >
                  <i class="fa-solid fa-user-tie"></i>
                  <span>Roles</span>
                </button>
              </>
            )}

            <button
              className="navbar-icon"
              style={{ position: "relative" }}
              onMouseEnter={() => {
                detailref.current.style.display = "block";
              }}
            >
              {userData && (
                <>
                  <i className="fa-solid fa-user"></i>
                  <span>{userData.userID}</span>

                  <aside
                    ref={detailref}
                    onMouseLeave={() => {
                      detailref.current.style.display = "none";
                    }}
                  >
                    <h2>Welcome, {userData.userID}</h2>
                    <blockquote style={{ marginTop: "1rem" }}>
                      <p>
                        <b>Email:</b> {userData.email}
                      </p>
                    </blockquote>
                    <blockquote>
                      <p>
                        <b>Mobile No.:</b> {userData.mobileNumber}
                      </p>
                    </blockquote>
                    <blockquote>
                      <p>
                        <b>Role :</b> {userData.role}
                      </p>
                    </blockquote>
                    {userData.role !== "Administrator" && (
                      <>
                        <blockquote>
                          <p>
                            <b>Account Status:</b>{" "}
                            {userData.isLocked === false
                              ? "Active"
                              : "Inactive"}
                          </p>
                        </blockquote>

                        <blockquote>
                          <p
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setdetailsrole(true);
                            }}
                          >
                            <b>View Your Permissions</b>
                          </p>
                        </blockquote>
                      </>
                    )}

                    <button
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        border: "2px solid black",
                      }}
                      onClick={() => setshowchangepasswordform(true)}
                    >
                      Change Password
                    </button>

                    <button
                      onClick={() => {
                        document.cookie = "token=; max-age=0; path=/;";
                        setisloggedout(true);
                        navigate("/");
                      }}
                    >
                      Logout
                    </button>
                  </aside>
                </>
              )}
            </button>
          </div>

          <i
            class={`fa-solid ${rightSide ? "fa-xmark" : "fa-bars"} fa-2x`}
            id="navbar-menu-toggle-icon"
            onClick={() => {
              togglemenu.current.style.top = `${navbarRef.current.clientHeight}px`;
              setMobileMode(true);
              if (togglemenu.current.style.display === "block") {
                togglemenu.current.style.display = "none";
                setRightSide(false);
              } else {
                togglemenu.current.style.display = "block";
                setRightSide(true);
              }
            }}
          ></i>
        </nav>
      </nav>
      {detailsrole && (
        <DetailsRoleTable
          setshowdetailsroletable={setdetailsrole}
          role={userData.role}
          isAdmin={false}
        />
      )}
    </>
  );
}

export default Navbar;
